import { ZonesEnum } from './tabs';

export const HEART_RATE_ZONES_COLORS = ['#C3CACA', '#6CC5EA', '#83C94A', '#F0C048', '#CC305C'];

export const POWER_ZONES_COLORS = {
  [ZonesEnum.Six]   : ['#E96A2F', '#F8EC52', '#6DD65D', '#72CAF3', '#26365D', '#474A4B'],
  [ZonesEnum.Seven] : ['#E7312B', '#EA6C30', '#F9EB50', '#6DD55B', '#72C9F7', '#233666', '#454A48'],
  [ZonesEnum.Eight] : ['#E6336A', '#E5322C', '#EA6C30', '#FBEB51', '#6FD457', '#73CBEB', '#243566', '#464B4B']
}
